const initialState = {
  inputs: {
    bank_accounts: [],
    person_shareholder: [],
    person_directors: [],
    person_authorized: [],
    other_uploads: []
  },
  errors: {},
  isCancel: false,
  isSuccess: false,
  isSave: false,
  isSubmit: false,
  preview: false,
  isFinish: false,
  allPreview: false,
  isLoader: true,
  step: 1,
  lastStep: 1
}

export default (state = initialState, action) => {
  const { type, payload } = action
  switch (type) {
    case 'ON_CHANGE':
      return {
        ...state,
        inputs: {
          ...state.inputs,
          [payload.name]: payload.value
        }
      }
    case 'ON_STEP_REGISTER':
      return {
        ...state,
        step: payload
      }
    case 'ON_LAST_STEP_REGISTER':
      return {
        ...state,
        lastStep: payload
      }
    case 'ON_PREVIEW_REGISTER':
      return {
        ...state,
        preview: payload
      }
    case 'ON_SAVE_REGISTER':
      return {
        ...state,
        isSave: payload
      }
    case 'ON_SUBMIT_REGISTER':
      return {
        ...state,
        isSubmit: !state.isSubmit
      }
    case 'ON_SET_ERROR':
      return {
        ...state,
        errors: {
          ...state.errors,
          [payload.name]: payload.value
        }
      }
    case 'ON_FINISH_REGISTER':
      return {
        ...state,
        isFinish: payload
      }
    case 'ON_SUCCESS_REGISTER':
      return {
        ...state,
        isSuccess: payload
      }
    case 'ON_ALL_PREVIEW_REGISTER':
      return {
        ...state,
        allPreview: payload || !state.allPreview
      }
    case 'ON_CANCEL_REGISTER':
      return {
        ...state,
        isCancel: payload
      }
    case 'ON_LOADER_REGISTER':
      return {
        ...state,
        isLoader: payload
      }
    case 'ON_SET_ALL_FORM':
      return {
        ...state,
        inputs: payload
      }
    case 'ON_CLEAR_REGISTER':
      return { ...initialState, isSuccess: true }
    default:
      return state
  }
}
